import {ProTable} from "@ant-design/pro-components";
import {Button} from "antd";
import {useState} from "react";

export default (props: any) => {
    const {showPage = true, onExport} = props;
    const columns = props.columns.map((item: any) => {
        return {
            ...item,
            search: Object.hasOwn(item, "search") || false,
            ellipsis: Object.hasOwn(item, "ellipsis")
                ? item.ellipsis
                : !Object.hasOwn(item, "render"),
            fixed: Object.hasOwn(item, "fixed")
                ? item.fixed
                : item.valueType && item.valueType == "option",
        };
    });
    const pagination = showPage
        ? {
            showSizeChanger: true,
            showTotal: (total: number) => `共 ${total} 条`,
            defaultPageSize: 10,
        }
        : false;

    return (
        <ProTable
            size={"small"}
            headerTitle={" "}
            bordered={true}
            pagination={props.pagination || pagination}
            options={false}
            search={columns.some((item: any) => item.search)}
            {...props}
            scroll={{x: props.scroll?.x || 1300, y: props.scroll?.y}}
            rowKey={props.rowKey || "id"}
            columns={
                props.noSN
                    ? columns
                    : [
                        {
                            title: "序号",
                            dataIndex: "index",
                            key: "index",
                            search: false,
                            width: 80,
                            render: (
                                _: string,
                                record: any,
                                index: number,
                                action
                            ) =>
                                (action?.pageInfo?.current!! - 1) *
                                action?.pageInfo?.pageSize!! +
                                index + 1,
                        },
                        ...columns,
                    ]
            }
            params={props.params}
            request={async (params, sort, filter) => {
                if (!props.request) {
                    return {
                        data: [],
                        total: 0,
                    };
                }
                const {data, total} = await props.request(params, sort, filter);
                return {
                    data: data,
                    total: total || data.length,
                };
            }}
        />
    );
};
